import { Dialog } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import TGButton from 'src/components/ui/TGButton';

type AlertInformationProps = {
  isOpen: boolean;
  custom?: boolean;
  title: string;
  text: string;
  danger?: string;
  textConfirmButton: string;
  onClose: () => void;
  onConfirm: () => void;
};

function AlertInformation(props: AlertInformationProps) {
  const { title, text, danger, custom, isOpen, textConfirmButton, onClose, onConfirm } = props;

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-40">
      <div
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-30 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div
            className="relative transform rounded-lg max-w-2xl bg-white px-8 py-8 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <button
              type="button"
              onClick={onClose}
              className="absolute right-[-28px] top-0 outline-none rounded-md text-white opacity-80 hover:opacity-100"
            >
              <span className="sr-only">Close</span>
              <XMarkIcon aria-hidden="true" className="h-6 w-6" />
            </button>

            <div className="text-black">
              <h1 className="text-2xl">{title}</h1>

              <div className="mt-8">
                <p className="text-base text-black">{text}</p>
              </div>

              <div className="mt-8">
                <p className="text-base text-black">{danger}</p>
              </div>
            </div>

            {custom && (
              <div className="flex justify-between mt-8 border-t pt-8">
                <TGButton type='button' onClick={onClose}>
                  Отмена
                </TGButton>

                <TGButton type='button' color='bluedark' onClick={onConfirm}>
                  {textConfirmButton}
                </TGButton>
              </div>
            )}
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default AlertInformation;
